import { ChatAvailabilityResult } from '@varo/graphql-schema-types';
import ChatBanner from 'features/chat/ChatBanner/ChatBanner';
import {
  ChatStatus,
  getBannerDescription,
  getBannerTitle,
  getStatusBanner,
} from 'features/chat/helpers/StatusBanner.helper';
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface StatusBannerProps {
  chatOutageMessage?: string;
  chatAvailability?: ChatAvailabilityResult;
  unableToConnect: boolean;
}

const StatusBanner = ({
  chatOutageMessage,
  chatAvailability,
  unableToConnect,
}: StatusBannerProps) => {
  const { t: translatedText } = useTranslation('chatStrings');
  const chatStatus = getStatusBanner(chatAvailability);

  const chatStatusMessage = translatedText(getBannerTitle(chatStatus));
  const chatStatusDescription = translatedText(
    getBannerDescription(chatStatus),
  );

  const message = unableToConnect
    ? translatedText(getBannerTitle(ChatStatus.Down))
    : chatStatusMessage;

  const description = unableToConnect
    ? translatedText(getBannerDescription(ChatStatus.Down))
    : chatStatusDescription;

  if ([ChatStatus.Offline, ChatStatus.Busy].includes(chatStatus)) {
    return (
      <ChatBanner
        message={chatStatusMessage}
        description={chatStatusDescription}
      />
    );
  }

  return (
    <ChatBanner
      message={message}
      description={description}
      chatOutageMessage={chatOutageMessage}
    />
  );
};

export default StatusBanner;
